








import { Component, Vue, Prop } from "vue-property-decorator";
import { toushiAuth } from "hfox/utils/toushi";

@Component
class ToushiAction extends Vue {
  @Prop() plan;

  loading = false;

  initing = false;

  detail: any = null;

  get meta() {
    const toushi_bind = this.$store.state.hfox.toushi_bind;
    const bound = this.detail?.toushi?.bound ?? false;
    const enabled = this.detail?.toushi?.enabled ?? false;
    const text = !toushi_bind
      ? this.$t("hfox.bind-with-toushi")
      : !bound
      ? this.$t("hfox.connect-with-toushi")
      : enabled
      ? this.$t("hfox.disable.sync.with.toushi")
      : this.$t("hfox.enable.sync.with.toushi");

    return { toushi_bind, text, bound, enabled };
  }

  async mounted() {
    this.initing = true;
    await this.requestPlanDetail();
    this.initing = false;
  }

  handleClick() {
    if (this.loading) return;

    if (!this.meta.toushi_bind) {
      this.handleRequestToushiAuth();
    } else if (!this.meta.bound) {
      this.handleConnectToushi();
    } else {
      this.handleToggleSync();
    }
  }

  handleRequestToushiAuth() {
    toushiAuth();
  }

  async requestPlanDetail() {
    try {
      this.detail = await this.$api.hfox.getPlanDetail(this.plan.id);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  async handleConnectToushi() {
    this.loading = true;
    try {
      await this.$api.hfox.createToushiConnection(this.plan.id);
      await this.requestPlanDetail();
      this.$common.utils.helper.message(
        this,
        {
          title: this.$t("hfox.toushi.connected") as string,
          description: this.$t("hfox.see.data.in.toushi") as string
        },
        {}
      );
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  async handleToggleSync() {
    this.loading = true;
    try {
      await this.$api.hfox.updateToushiConnection(
        this.plan.id,
        !this.meta.enabled
      );
      await this.requestPlanDetail();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default ToushiAction;
